import React from 'react';
import Header from 'components/molecules/sms-autoreply-settings/header';
import { smsAutoReplySettingsDataSource } from 'infrastructure/data-sources/sms-autoreply-settings';
import SettingsItem from 'components/molecules/sms-autoreply-settings/settings-item';
import ScrollToTopButton from 'components/atoms/scroll-to-top-button';
import { useSmsAutoReplySettings } from 'infrastructure/hooks/smsAutoReplySettings/use-sms-autoreply-settings';

import s from './styles.module.scss';

import type { ISmsAutoReplySettingsTypeItem } from 'infrastructure/data-sources/sms-autoreply-settings';

const SmsAutoReplySettings = () => {
  const { smsAutoReplySettings } = useSmsAutoReplySettings();
  const dataSource = smsAutoReplySettingsDataSource();

  return (
    <div>
      <Header />
      <div className={s.body}>
        {dataSource.map((item: ISmsAutoReplySettingsTypeItem) => (
          <SettingsItem
            {...item}
            setting={item}
            available={
              smsAutoReplySettings?.find((el) => el.key === item.key)?.available
            }
          />
        ))}
      </div>
      <ScrollToTopButton />
    </div>
  );
};

export default SmsAutoReplySettings;
